__turbopack_context__.v({
  "card": "ConnectionPreviewCard-module__G6ng1G__card",
  "email": "ConnectionPreviewCard-module__G6ng1G__email",
  "identity": "ConnectionPreviewCard-module__G6ng1G__identity",
  "serviceIcon": "ConnectionPreviewCard-module__G6ng1G__serviceIcon",
  "text": "ConnectionPreviewCard-module__G6ng1G__text",
  "title": "ConnectionPreviewCard-module__G6ng1G__title",
});
